import React, { useState } from 'react';

interface AMPImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  layout?:
    | 'responsive'
    | 'fixed'
    | 'fill'
    | 'fixed-height'
    | 'flex-item'
    | 'container'
    | 'nodisplay';
  priority?: boolean;
  onLoad?: () => void;
  onError?: () => void;
}

// Helper function to check AMP environment - moved outside component
const checkIsAMP = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.search.includes('amp=1') || document.documentElement.hasAttribute('amp');
};

export const AMPImage: React.FC<AMPImageProps> = ({
  src,
  alt,
  width,
  height,
  className = '',
  layout = 'responsive',
  priority = false,
  onLoad,
  onError,
}) => {
  const [isAMP] = useState<boolean>(() => checkIsAMP());

  if (isAMP) {
    return (
      <amp-img
        src={src}
        alt={alt}
        width={width}
        height={height}
        layout={layout}
        className={className}
        data-testid="amp-image"
        on={`load:${onLoad ? 'onLoadEvent' : ''};error:${onError ? 'onErrorEvent' : ''}`}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={`${className} lazy-image`.trim()}
      loading={priority ? 'eager' : 'lazy'}
      onLoad={onLoad}
      onError={onError}
      data-testid="regular-image"
    />
  );
};

export default AMPImage;
